import { ILog } from '../../../global/types';
import { StudentTermsQuery } from '../../queries/student_terms_query';
import { StudentTypesQuery } from '../../queries/student_types_query';
import { MemberDatasource } from '../../../global/datasources/member_datasource';
import { StudentType } from '../../builders/student_type_builder';
import { ICommand } from 'core-ts-types';
import { College } from '../../../transfer/builders/college_builder';
import { CollegeQueryResults } from '../../../transfer/builders/college_query_results_builder';
import { ProfileServant } from '../../servants/profile_servant';
import { ErrorsDict, IFormErrorService } from '../../../global/services/form_error_service/form_error_service';
import { IServerResponse } from '../../../global/interfaces/server_response';
import { Profile } from '../../../authentication/builders/profile_builder';
import { ProfileModel } from '../../../authentication/models/profile_model';

export class AdditionalInformationController {
  private additional_information_form: ng.IFormController;
  private universityShortName: string;
  private selectedStudentType: StudentType;

  private info: Profile;
  private today = moment().format('YYYY-MM-DD');

  private errors: ErrorsDict;

  querySet: {
    has_more: boolean;
    result: College[];
  };

  dropdownHeader: string = '';
  newCollegeError?: string;
  currentlyEnrolledCollege: string;
  shouldShowWriteInCollegeInput: boolean = false;

  constructor(
    private ngStudentTermsQuery: StudentTermsQuery,
    private ngStudentTypesQuery: StudentTypesQuery,
    private ngMemberDatasource: MemberDatasource,
    private saveAdditionalInformationCommand: ICommand,
    private ngProfileModel: ProfileModel,
    private ngProfileServant: ProfileServant,
    private $state: ng.ui.IStateService,
    private log: ILog,
    private searchTransferCollegesCommand: ICommand,
    private selectTransferCollegeCommand: ICommand,
    private $element: ng.IRootElementService,
    private formErrorService: IFormErrorService
  ) {
    this.universityShortName = this.ngMemberDatasource.read().core_config.short_name;
    this.info = ngProfileServant.cleanForForm(this.ngProfileModel.read());
    this.currentlyEnrolledCollege = this.info.current_college_name || '';
  }

  get currentlyEnrolledCollegeName(): string {
    return this.currentlyEnrolledCollege;
  }

  updateCurrentlyEnrolledStatus($event: CustomEvent): void {
    const oldValue = this.info.currently_enrolled;
    const newValue = $event.detail.value;

    if (newValue !== oldValue) {
      this.info.currently_enrolled = $event.detail.value;
    }
  }

  isValid(writeInCollegeName: string): boolean {
    return /^(\w*[-\s,#\./()':&\p{L}]*)+$/gu.test(writeInCollegeName);
  }

  addWriteInCollege(): void {
    const writeInCollegeInput = document.getElementById('additional-information--new-college-name') as HTMLInputElement;
    const validationNoticeElement = document.getElementById(
      'additional-information--new-college-name-validation-notice'
    ) as HTMLElement;
    const writeInCollegeName = writeInCollegeInput.value;
    this.newCollegeError = undefined;
    validationNoticeElement.setAttribute('validation-notice', '');
    if (!_.isEmpty(writeInCollegeName)) {
      if (this.isValid(writeInCollegeName)) {
        this.info.currently_enrolled_other_college_name = writeInCollegeName;
        this.currentlyEnrolledCollege = writeInCollegeName;
        writeInCollegeInput.value = '';
        this.shouldShowWriteInCollegeInput = false;
      } else {
        this.newCollegeError =
          'This field can only contain alphanumeric characters, spaces, commas, hash symbols, periods, hyphens, round brackets, apostrophes, forward slashes, ampersands, and/or underscores';
        validationNoticeElement.setAttribute('validation-notice', this.newCollegeError);
      }
    }
  }

  showWriteInCollegeInput(): void {
    this.$element.find('hi-typeahead').removeAttr('opened');

    if (!this.shouldShowWriteInCollegeInput) {
      this.errors = {};
      this.toggleShowWriteInCollegeInput();
    }
  }

  toggleShowWriteInCollegeInput(): void {
    this.shouldShowWriteInCollegeInput = !this.shouldShowWriteInCollegeInput;
  }

  onSearchChange($event: any): void {
    this.searchTransferCollegesCommand($event.detail.value, false).then(
      (collegeQueryResponse: CollegeQueryResults): void => {
        this.querySet = {
          has_more: collegeQueryResponse.has_more,
          result: collegeQueryResponse.colleges
        };

        //TODO: Replace below code by search_results_strategy after moving it to lib
        if (_.isEmpty(this.querySet.result)) {
          this.dropdownHeader = 'There are no results for your search. Refine your search for better results.';
        } else if (this.querySet.result.length === 1) {
          this.dropdownHeader = '1 result was found.';
        } else if (!this.querySet.has_more && this.querySet.result.length > 1) {
          this.dropdownHeader = `${this.querySet.result.length} results were found.`;
        } else if (this.querySet.has_more) {
          this.dropdownHeader = 'Your search is limited to 20 results, add more text to narrow it down.';
        }
      }
    );
  }

  onSelectQueryItem($event: any): void {
    this.selectTransferCollegeCommand(JSON.parse($event.detail.value)).then(() => {
      this.$element.find('hi-typeahead')[0]['searchValue'] = '';
    });
    const college = JSON.parse($event.detail.value);
    this.currentlyEnrolledCollege = college.name;
    this.info.currently_enrolled_college = college.nk;
  }

  onRemoveCurrentlyEnrolledCollege(): void {
    this.currentlyEnrolledCollege = '';
    this.info.currently_enrolled_other_college_name = '';
    this.info.currently_enrolled_college = null;
  }

  isRedirectedFromConfirmation(): boolean {
    return this.$state.params.source === 'account-creation';
  }

  // FIXME radio group should handle this
  getSelectedStudentTypeIndex(): number {
    return (
      _.indexOf(
        this.ngStudentTypesQuery.result,
        _.find(this.ngStudentTypesQuery.result, (studentType) => studentType.name === this.info.student_type)
      ) + 1
    );
  }

  studentType_onValueChanged($event: CustomEvent) {
    if (!_.isUndefined($event.detail.value) && $event.detail.value !== '{{ studentType.name }}') {
      this.info.student_type = $event.detail.value;
    }
  }

  getTermDropdownPlaceholder(): string {
    return this.info.term_name || 'Term';
  }

  term_onValueChanged($event: CustomEvent) {
    this.setTermId(parseInt($event.detail.value, 10));
  }

  setTermId(id: number) {
    this.info.term_id = id;
  }

  goToTransferCredits() {
    return this.$state.go('my.transfer.credits');
  }

  isFormInvalid(): boolean {
    return !_.isEmpty(this.errors);
  }

  isCurrentlyEnrolled(): boolean {
    return !!this.info.currently_enrolled;
  }

  submitForm(): void {
    this.errors = {};
    const birthDateElement = this.$element.find('#additional-information--date-of-birth')[0] as HTMLInputElement;
    if (birthDateElement && !_.isEmpty(birthDateElement.validationMessage)) {
      this.errors.date_of_birth = birthDateElement.validationMessage;
      return;
    }

    let info = this.ngProfileServant.cleanForServer(this.info);

    this.saveAdditionalInformationCommand(info)
      .then(() => {
        this.isRedirectedFromConfirmation()
          ? this.goToTransferCredits()
          : this.log.user.success({
              content: 'Your information & preferences were saved',
              timeout: 10000,
              dismissOnTimeout: true,
              dismissButton: true
            });
      })
      .catch((response: ng.IHttpPromiseCallbackArg<IServerResponse>) => {
        this.errors = this.formErrorService(response.data!.error);
      });
  }
}

angular
  .module('capability-ng-user-app')
  .controller('ngAdditionalInformationController', AdditionalInformationController);



// WEBPACK FOOTER //
// ./app/lib/user_app/views/additional_information/additional_information.ts